module.exports = __webpack_public_path__ + "media/images/icon-unlock-f40270ac99e78e8850396f7041db3387.svg";